<div class="video-container" [ngClass]="{'iphone':isIPhone}" style="width: 100%;height:100%">
    <div class="video-box simple" *ngIf="isPlayerReady && playerSelection == 0">
        <vg-player (onPlayerReady)="onPlayerReady($event)" id="main-player" *ngIf="!!media">

            <!-- <div class="needTouch" (click)="toPlay()" *ngIf="needUserTouch">
            </div> -->

            <vg-buffering></vg-buffering>
            <vg-controls *ngIf="playSuccess" class="player-title-bar simple header-bg" [vgAutohide]="autoHide" [vgAutohideTime]="2.5" style="pointer-events: none;">
                <div class="simple-controll-top-right" style="pointer-events: auto;">
                    <vg-mute class="control-item"></vg-mute>
                </div>
            </vg-controls>

            <div class="simple-stick-bottom">
                <vg-scrub-bar [previewFormat]="previewFormat" style="opacity: 1 !important;">
                    <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                    <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                </vg-scrub-bar>
            </div>

            <vg-controls class="bg-overlayer simple" [vgAutohide]="autoHide" [vgAutohideTime]="2.5">
                <div class="simple-controll-bottom-left">
                    <!-- <vg-play-pause class="control-item"></vg-play-pause> -->
                    <div class="timeline notranslate" *ngIf="!!api && api?.totalTime >= 3600000">
                        <vg-time-display class="control-item" vgProperty="current" vgFormat="hh:mm:ss">
                        </vg-time-display>
                        <div class="splash">/</div>
                        <vg-time-display class="control-item" vgProperty="total" vgFormat="hh:mm:ss">
                        </vg-time-display>
                    </div>
                    <div class="timeline notranslate" *ngIf="!!api && api?.totalTime < 3600000">
                        <vg-time-display class="control-item" vgProperty="current" vgFormat="mm:ss"
                            style="width: 42px;">
                        </vg-time-display>
                        <div class="splash">/</div>
                        <vg-time-display class="control-item" vgProperty="total" vgFormat="mm:ss" style="width: 42px;">
                        </vg-time-display>
                    </div>
                </div>
            </vg-controls>

            <a class="cover-nav-link" [routerLink]="['/watch']" [queryParams]="{ v: video?.key }"></a>

            <video class="simple-video-player" id="video_player" preload="auto" controlsList="nodownload" autobuffer [muted]="muted"
                webkit-playsinline="webkit-playsinline" playsinline="playsinline" [vgMedia]="myMedia" #myMedia
                #vgHls="vgHls" [vgHls]="media.src" (error)="errorHandler($event)" [ngStyle]="videoStyle"
                (onHlsError)="hlsErrorHandler($event)" (onGetBitrates)="onMasterPlayParsed($event)"
                x-webkit-airplay="allow" (onLevelChanged)="onLevelChanged($event)" poster="{{poster}}"
                >
            </video>
        </vg-player>

        <!--在其它浏览器中出现BUG-->
        <!-- <div class="video-loader" *ngIf="isChrome">
            <video muted autobuffer webkit-playsinline playsinline *ngIf="loadMedia" (error)="publicLoader($event)">
                <source [src]="loadMedia.src" [type]="loadMedia.type">
            </video>
        </div> -->
    </div>

    <div class="video-box" [style.height.px]="playerHeight" *ngIf="isPlayerReady && playerSelection == 1">
        <h3>无法播放</h3>
    </div>
</div>